import type { MiniAppDefinition, MiniAppSlot } from './types';

/**
 * Identity helper for declaring a mini-app. Returns the definition unchanged —
 * it exists so app modules read as `export default defineMiniApp({...})` and to
 * give us one place to add validation later.
 */
export function defineMiniApp(def: MiniAppDefinition): MiniAppDefinition {
  return def;
}

/**
 * Pure registry selectors over a supplied app list — the framework never
 * imports the concrete apps. The host composes the list (`ALL_MINI_APPS`) and
 * hands it to `MiniAppActions`, so adding an app is a one-line change at the
 * composition root with no framework edit.
 */
export function getMiniAppsForSlot(
  apps: readonly MiniAppDefinition[],
  slot: MiniAppSlot,
): readonly MiniAppDefinition[] {
  return apps.filter((app) => app.slots.includes(slot));
}

export function getMiniApp(
  apps: readonly MiniAppDefinition[],
  id: string,
): MiniAppDefinition | null {
  return apps.find((app) => app.id === id) ?? null;
}
